// extracted by mini-css-extract-plugin
export default {"container":"OurStrategy_container__E1Ip2","title":"OurStrategy_title__x5Sg-","strategy":"OurStrategy_strategy__aEJNJ","strategy-img":"OurStrategy_strategy-img__vwHol"};